import Vue from 'vue'
import Router from 'vue-router'
import AppLayout from '../components/admin/AppLayout'
import AuthLayout from '../components/auth/AuthLayout'
import lazyLoading from './lazyLoading'
import store from '../store'

Vue.use(Router)

const demoRoutes = []
if (process.env.NODE_ENV === 'development') {
  const VueBook = require('vue-book')

  demoRoutes.push(
    VueBook.createRoute({
      requireContext: require.context('./..', true, /.demo.vue$/),
      path: '/demo'
    }),
    VueBook.createRoute({
      requireContext: require.context('./../components', true, /.vue$/),
      path: '/presentation'
    })
  )

  Vue.use(VueBook.VueBookComponents)
}

const EmptyParentComponent = {
  template: '<router-view></router-view>'
}
const router = new Router({
  routes: [
    {
      path: '*',
      redirect: { name: 'dashboard' }
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          name: 'login',
          path: 'login',
          component: lazyLoading('auth/login/Login')
        },
        {
          name: 'account',
          path: 'account',
          component: lazyLoading('auth/login/Account')
        },
        {
          path: '',
          redirect: { name: 'login' }
        }
      ]
    },
    {
      path: '/404',
      component: EmptyParentComponent,
      children: [
        {
          name: 'not-found-advanced',
          path: 'not-found-advanced',
          component: lazyLoading('pages/404-pages/VuesticPageNotFoundSearch')
        },
        {
          name: 'not-found-simple',
          path: 'not-found-simple',
          component: lazyLoading('pages/404-pages/VuesticPageNotFoundSimple')
        },
        {
          name: 'not-found-custom',
          path: 'not-found-custom',
          component: lazyLoading('pages/404-pages/VuesticPageNotFoundCustom')
        },
        {
          name: 'not-found-large-text',
          path: '/pages/not-found-large-text',
          component: lazyLoading('pages/404-pages/VuesticPageNotFoundLargeText')
        }
      ]
    },
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          component: lazyLoading('dashboard/Dashboard'),
          default: true
        },
        {
          name: 'extensions',
          path: 'extensions',
          component: EmptyParentComponent,
          children: [
            {
              name: 'all-extensions',
              path: 'all',
              component: lazyLoading('extensions/extensions')
            },
            {
              name: 'extension-create',
              path: 'create',
              component: lazyLoading('extensions/create')
            },
            {
              name: 'extension-update',
              path: 'update/:id',
              component: lazyLoading('extensions/Update')
            }
          ]
        },
        {
          name: 'reporting',
          path: 'reporting',
          component: EmptyParentComponent,
          children: [
            {
              name: 'call-reporting',
              path: 'call-reporting',
              component: lazyLoading('reporting/CallReporting')
            }
          ]
        },
        {
          name: 'billing',
          path: 'billing',
          component: EmptyParentComponent,
          children: [
            {
              name: 'billing-rates',
              path: 'rates',
              component: lazyLoading('billing/Rates')
            },
            {
              name: 'billing-refill',
              path: 'refill',
              component: lazyLoading('billing/Refill')
            },
            {
              name: 'billing-payments',
              path: 'payments',
              component: lazyLoading('billing/Payments')
            },
            {
              name: 'billing-charges',
              path: 'charges',
              component: lazyLoading('billing/Charges')
            },
            {
              name: 'billing-invoices',
              path: 'invoices',
              component: lazyLoading('billing/Invoices')
            }
          ]
        },
        {
          name: 'inno-support',
          path: 'inno-support',
          component: lazyLoading('support/InnoSupport')
        },
        {
          name: 'customers',
          path: 'customers',
          component: EmptyParentComponent,
          children: [
            {
              name: 'all-customers',
              path: 'all',
              component: lazyLoading('customers/customers')
            },
            {
              name: 'customer-create',
              path: 'create',
              component: lazyLoading('customers/create')
            }
          ]
        },
        {
          name: 'all-packages',
          path: 'all-packages',
          component: lazyLoading('packages/Packages')
        },
        {
          name: 'all-invoices',
          path: 'all-invoices',
          component: lazyLoading('packages/Invoices')
        },
        {
          name: 'usage',
          path: 'usage',
          component: EmptyParentComponent,
          children: [
            {
              name: 'billing-summary',
              path: 'summary',
              component: lazyLoading('billing/Summary')
            },
            {
              name: 'billing-detailed',
              path: 'detailed',
              component: lazyLoading('billing/Detailed')
            }
          ]
        },
        {
          name: 'settings',
          path: 'settings',
          component: EmptyParentComponent,
          children: [
            {
              name: 'customer-settings',
              path: 'customer-settings',
              component: lazyLoading('customers/settings')
            },
            {
              name: 'customer-create-field',
              path: 'create-field',
              component: lazyLoading('customers/createField')
            }
          ]
        },
        {
          name: 'crm',
          path: 'crm',
          component: EmptyParentComponent,
          children: [
            {
              name: 'crm-integrate',
              path: 'crm/integrate',
              component: lazyLoading('crm/integrate')
            }
          ]
        },
        {
          name: 'conference-bridge',
          path: 'conference-bridge',
          component: lazyLoading('conference-bridge/ConferenceBridge')
        },
        {
          name: 'callflow',
          path: 'conference-bridge/callflow',
          component: lazyLoading('conference-bridge/CallFlow')
        }
      ],
      meta: { requiresAuth: true, requiresAccount: true }
    }
  ]
})
router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAccount = to.matched.some(record => record.meta.requiresAccount)
  const token = store.getters.token
  const account = JSON.parse(localStorage.getItem('account'))

  if (requiresAccount && token && !account) {
    next({
      path: '/auth/account',
      query: {
        redirect: to.fullPath
      }
    })
  } else if (requiresAuth && token) {
    next()
  } else if (requiresAuth && !token) {
    next({
      path: '/auth/login',
      query: {
        redirect: to.fullPath
      }
    })
  } else if (to.path === '/auth/login' && token) {
    next({
      path: '/admin/dashboard',
      query: {
        redirect: to.fullPath
      }
    })
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})
export default router
